var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('c-button-link',{attrs:{"theme":"primary","icon":_vm.icon,"data-toggle":"tooltip","title":_vm.tooltipTitle},on:{"click":_vm.copy}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }